import React from 'react';
import Title from '../layouts/Title';
import ContactLeft from './ContactLeft';

const Contact = () => {
  return (
    <section id="contact" className="w-full py-20 border-b-[1px] border-b-gray-800">
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact With Me" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col items-center justify-center">
          <ContactLeft />
        </div>
      </div>
    </section>
  );
};

export default Contact;
